import { useContext } from "react";
import { GlobalContext } from "../../context/GlobalState";
export default function AboutTab() {
	const { isLoading, setIsLoading } = useContext(GlobalContext);

	const handleCVdownload = () => {
		setIsLoading(true);
		const pdfPath =
			process.env.PUBLIC_URL + "/downloadableContent/KeremunceCV.pdf";

		const link = document.createElement("a");
		link.href = pdfPath;
		link.download = "keremunceCV.pdf";
		link.click();

		setTimeout(() => {
			setIsLoading(false);
		}, 1000); // Simüle edilen indirme süresi
	};
	return (
		<>
			<section className="AboutTab-container">
				<div>
					<div className="subtitle">
						<p>
							<i className="ti-user text-orange-600"></i> Who am I?
						</p>
					</div>
					<div className="title">
						<h2>About Me</h2>
					</div>
					<div className="inner-container">
						{/* <div className="image-container">
                            <img src={process.env.PUBLIC_URL + '/images/kerem2.jpg'} alt="" />
                        </div> */}

						<div className="content-container">
							<div className="card bio space-y-4">
								<h6 className="title text-lg font-semibold mb-2">About Me</h6>
								<p className="desc text-base leading-relaxed">
									I'm a developer with a deep passion for building clean,
									user-focused systems—especially ones that make data visually
									engaging and functional. I started my journey in a mobile app
									startup, where I was involved in every phase of product
									development, from engineering to growth strategy.
								</p>
								<p className="desc text-base leading-relaxed">
									I enjoy solving real-world problems through thoughtful design
									and scalable code—and I’m always looking for the next
									challenge.{" "}
								</p>
							</div>
						</div>

						<div className="downloadCV-container">
							<span className="download-loader"></span>
							<button
								onClick={handleCVdownload}
								className={`CVdownloadBtn ${isLoading ? "loading" : ""}`}
							>
								{isLoading ? "Downloading" : "Download CV"}{" "}
								<i className="ti-download bottom-icon"></i>
								<i className="ti-download top-icon"></i>
							</button>
						</div>
						<div className="subcontent-container card info">
							<div>
								<p>Birth</p>
								<p>19/12/2004</p>
							</div>
							<div>
								<p>Email</p>
								<p>info@keremunce.com</p>
							</div>
							<div>
								<p>Residence</p>
								<p>Turkey </p>
							</div>
							<div>
								<p>Phone</p>
								<p>+90 539 482 90 04</p>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
}
